import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  TextField,
  MenuItem,
  Button,
  Box,
  Typography,
} from "@mui/material";
import React, { useState, useContext, useEffect } from "react";
import PsContext from "../../context";
import { PlusCircleOutlined } from "@ant-design/icons";
import {
  _LIST_STAFFS,
  _LIST_TASK_CATEGORIES,
  _LIST_TASK_LOG,
  _LIST_TASK_PRIORITIES,
  _LIST_TASKS,
  _UPDATE_TASK_RESPONSE,
} from "../../models/task";
import { Dialog, List, SwipeAction, Toast } from "antd-mobile";
import { momentDate, MuiModalWindow } from "../../utils";
import AddTask from "./addTask";
import moment from "moment";

const TaskResponse = (props) => {
  const context = useContext(PsContext);
  const [selTaskStatus, setSelTaskStatus] = useState(null);
  const [comment, setComment] = useState(null);

  const handleSubmit = () => {
    // Validate all fields
    if (!comment || !selTaskStatus) {
      setErrorMessage("Please fill in all required fields.");
      return;
    }

    // Create a task object
    const taskData = {
      task_id: props.dataSource.id,
      updated_by: context.user.uuid,
      status_update: selTaskStatus,
      comment: comment,
    };
    _UPDATE_TASK_RESPONSE(taskData)
      .then((res) => {
        Toast.show({
          icon: "success",
          content: res.message ? res.message : "Task Activity updated!",
        });
        if (props.onSuccess) props.onSuccess();
      })
      .catch((error) => {
        console.error("Error updating Task Activity:", error);
        Toast.show({
          icon: "fail",
          content: "Error updating Task Activity. Please try again.",
        });
        if (props.onSuccess) props.onSuccess();
      });
  };

  return (
    <>
      <Card>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <TextField
                select
                fullWidth
                label="Update Status"
                value={selTaskStatus}
                onChange={(e) => setSelTaskStatus(e.target.value)}
              >
                <MenuItem value={"completed"}>Completed</MenuItem>
                <MenuItem value={"processing"}>Processing</MenuItem>
                <MenuItem value={"overdue"}>Overdue</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Comment"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                multiline
                rows={4}
                required
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={2} alignItems="flex-end">
            <Grid item xs={12} md={3}>
              <Button variant="contained" fullWidth onClick={handleSubmit}>
                Update
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};

export default TaskResponse;
